import './TrialBanner.css'
import React from 'react'

import Content from '../components/Content'

export default ({ title, content }) =>
    <section className='trial-banner device-banner'>
        <img src="/images/device-banner.png" alt="Available on any device" />
        <div className='trial-banner--content'>
            {title && <h3>{title}</h3>}
            {content && <Content src={content} />}
        </div>
    </section>


// WEBPACK FOOTER //
// ./src/components/DeviceBanner.js